import { render, staticRenderFns } from "./commod.vue?vue&type=template&id=3980ae76&scoped=true&"
import script from "./commod.vue?vue&type=script&lang=js&"
export * from "./commod.vue?vue&type=script&lang=js&"
import style0 from "./commod.vue?vue&type=style&index=0&id=3980ae76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3980ae76",
  null
  
)

export default component.exports